import client from './client';

export default (function SlideshowService() {
  let service;

  if (!service) {
    service = client.service('slideshow');
  }

  return service;
}());
